import script from "./bootstrap-button-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./bootstrap-button-dropdown.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__